export const structuredStoreJson = (venue) => {
  return {
    "@type": "Store",
    "name": venue?.name,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": venue?.streetAddress_line1,
      "addressLocality": venue?.city,
      "addressRegion": venue?.state,
      "postalCode": venue?.zip_code,
      "addressCountry": venue?.country
    },
    "telephone": venue?.phone,
    "url": window.posabitmenuwidget.ecomm_url || window.location.href,
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": venue?.latitude,
      "longitude": venue?.longitude
    },
    "openingHoursSpecification": venue?.opening_hours?.map((hour) => {
      return {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": hour?.day,
        "opens": hour?.open_time,
        "closes": hour?.close_time
      };
    })
  }
}

export const structuredProductJson = (product, variant, productType, displayImage) => {
  return {
    "@type": "Product",
    "url": window.location.href,
    "name": variant?.name,
    "description": product?.description,
    "sku": variant?.name,
    "brand": {
      "@type": "Brand",
      "name": product?.brand
    },
    "weight": {
      "@type": "QuantitativeValue",
      "value": variant?.unit,
      "unitCode": variant?.unit_type
    },
    "category": productType?.name,
    "image": displayImage,
    "offers": {
      "@type": "Offer",
      "priceCurrency": "USD",
      "price": (variant?.price_cents / 100).toFixed(2),
      "itemCondition": "https://schema.org/NewCondition",
      "availability": "https://schema.org/InStock",
      "url": window.location.href
    }
  }
}

export const structuredProductCategoryJson = (category) => {
  return     {
    "@type": "CollectionPage",
    "url": window.location.href,
    "inLanguage": "en-US",
    "name": category,
  }
}

export const structuredWebsiteJson = (venue) => {
  return {
    "@type": "WebSite",
    "name": venue?.name,
    "url": window.posabitmenuwidget.ecomm_url || window.location.href,
    "description": venue?.description || "Explore our menu for the best cannabis products.",
    "publisher": {
      "@type": "Organization",
      "name": venue?.name,
      "logo": venue?.logo_medium
    },
    // "potentialAction": {
    //   "@type": "SearchAction",
    //   "target": `${window.location.origin}/search?q={search_term_string}`,
    //   "query-input": "required name=search_term_string"
    // }
  }
}

export const setLdScript = (ldData) => {
  const head = document.head;
  // Remove existing ld+json script if it exists
  const existingScript = document.querySelector('script[type="application/ld+json"]');
  if (existingScript) {
    head.removeChild(existingScript);
  }

  const ldjson = {
    "@context": "https://schema.org",
    "@graph": ldData
  };
  

  // Create a new script element for ld+json
  if (!ldjson || Object.keys(ldjson).length === 0) {
    console.warn("No structured data provided to setLdScript.");
    return;
  }
  if (typeof ldjson !== 'object') {
    console.error("Invalid structured data format. Expected an object.");
    return;
  }
  if (!ldjson['@context']) {
    console.error("Structured data must include '@context'.");
    return;
  }
  // Create the script element
  if (!document.head) {
    console.error("Document head not found. Cannot append structured data script.");
    return;
  }

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(ldjson);
  document.head.appendChild(script);
}

export const setMetaElements = (metaElements) => {
  const head = document.head;
  metaElements.forEach((metaElement) => {
    let existingMeta = document.querySelector(`meta[property="${metaElement.property}"]`);
    if (existingMeta) {
      existingMeta.setAttribute('content', metaElement.content);
    } else {
      const element = document.createElement('meta');
      Object.keys(metaElement).forEach((key) => {
        element.setAttribute(key, metaElement[key]);
      });
      head.appendChild(element);
    }
  });
}

export const setMetaDescription = (description) => {
  if (!description) {
    console.warn("No description provided to setMetaDescription.");
    return;
  }
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', description);
  } else {
    const newMeta = document.createElement('meta');
    newMeta.name = 'description';
    newMeta.content = description;
    document.head.appendChild(newMeta);
  }
}




